import { ComponentProps } from 'react'
import { Icon, Tooltip } from '@/components/atoms'

type InfoTextProps = {
    text: string
    icon?: ComponentProps<typeof Icon>['name'] | null
    tooltipContent?: string
    className?: string
}

export const InfoText: React.FC<InfoTextProps> = ({
    text,
    icon = 'info',
    tooltipContent,
    className = '',
}) => {
    return (
        <span
            className={`text-label-small inline-flex cursor-default items-center gap-1 font-normal ${className}`}
            data-testid="info-text-container"
        >
            {text}
            {icon && (
                <Tooltip
                    content={tooltipContent}
                    name="info-text-tooltip"
                    show
                    className="!max-w-[194px]"
                >
                    <div className="flex items-center">
                        <Icon
                            name={icon}
                            className="text-icon-small text-azure"
                            data-testid="info-text-icon"
                        />
                    </div>
                </Tooltip>
            )}
        </span>
    )
}
